import { useMutation } from 'react-query'

import { api } from '../../../api'
import { type BankDataPersistence } from '../../../../types/persistence/bank-data-persistence'

const updateExpertBankData = async (
  id: number,
  data: BankDataPersistence
): Promise<BankDataPersistence> => {
  const response = await api.put<BankDataPersistence>(
    `/experts/${id}/bank-data`,
    data
  )
  return response.data
}

export const useExpertBankDataMutation = () => {
  return useMutation({
    mutationFn ({ id, data }: { id: number, data: BankDataPersistence }) {
      return updateExpertBankData(id, data)
    },
  })
}
